module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "pulse"
    }
  }, [(_vm.compIsVisible) ? _c('button', {
    staticClass: "checkbtn bg-light",
    class: {
      checked: _vm.compIsChecked
    },
    on: {
      "click": _vm.emitClick
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/checked-accent.svg"
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79426d54"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/elements/CheckBtn.vue
// module id = 648
// module chunks = 0